<mat-nav-list style="overflow-x: hidden;">
  <app-menu-list-item
    *ngFor="let item of menu"
    [item]="item"

  ></app-menu-list-item>
</mat-nav-list>
